<style lang="scss"></style>

<!-- eslint-disable -->
<template>
  <section class="participants-add">
    <p class="text-center large-font text-primary"><i class="fas fa-long-arrow-alt-down"></i></p>
    <h5 class="mb-2">Choose Participants to Add</h5>

    <section v-if="!loading">
      <section v-if="extraParticipants.length">
        <b-table
          class="data-table"
          hover
          :items="extraParticipants"
          :fields="headers"
          :current-page="currentPage"
          :per-page="filters.limit"
          :responsive="true"
        >
          <template #cell(birthDateAndAge)="data">
            <span class="d-inline-block" style="width: 115px">{{ data.item.birthDateAndAge }}</span>
            <span v-if="data.item.under18 && !data.item.safeguarded_at_prison" class="badge badge-danger badge-pill">UNDER 18</span>
            <span v-else-if="data.item.under18  && data.item.safeguarded_at_prison"
                  class="badge badge-success badge-pill">UNDER 18</span>
          </template>

          <template #cell(actions)="data">
            <b-btn variant="link" @click="$emit('view', data.item)">
              View
            </b-btn>
          </template>

          <template #cell(add)="data">
            <b-btn @click="showModal('modal-add-participant', true, data.item)" size="sm" variant="success"><span
              class="fa fa-plus"></span></b-btn>
          </template>

        </b-table>
        <b-row class="p-1" v-if="(extraParticipants.length > filters.limit) && extraParticipants.length !== 0">
          <b-col md="6" class="m-1" v-if="extraParticipants.length > filters.limit">
            <b-pagination :total-rows="extraParticipants.length" :per-page="filters.limit" v-model="currentPage"
                          class="my-0"/>
          </b-col>
          <p v-if="extraParticipants.length === 0" class="col-6 ml-2 my-1">No calls to show</p>
        </b-row>
      </section>

      <p v-else>Visitor has no Additional Participants left to add.</p>
    </section>

    <b-spinner v-else variant="primary" label="Loading..."></b-spinner>

    <b-modal id="modal-add-participant" hide-footer>
      <warning-modal key="add-warning" title="Are you sure you want to add participant"
                     :subtitle="activeParticipant.firstname + ' ' + activeParticipant.lastname + '?'"
                     :note="getNote(activeParticipant)"
                     @close="closeAllModalAndRefresh()" @ok="addParticipant(activeParticipant)" v-if="activeParticipant"
                     :call="activeParticipant"></warning-modal>
    </b-modal>
  </section>
</template>
<!-- eslint-enable -->

<script>
import {mapState} from 'vuex';
import AdditionalVisitorsService from '@/services/AdditionalVisitorsService';
import WarningModal from '@/components/modals/WarningModal';
import moment from 'moment';

export default {
  components: {
    WarningModal,
  },
  props: {},
  data() {
    return {
      headers: [
        {key: 'add', label: 'Add'},
        {key: 'fullName', label: 'Name'},
        {key: 'birthDateAndAge', label: 'Date of Birth'},
        {key: 'actions', label: ''},
      ],
      activeParticipant: null,
      loading: false,
      extraParticipants: [],
      currentPage: 1,
      filters: {
        limit: 5,
      }
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
      call: state => state.callDetails.call,
      additionalVisitors: state => state.callDetails.additionalVisitors,
    }),
  },
  mounted() {
    this.getParticipants();
  },
  methods: {
    showModal(name, value, person = null) {
      this.activeParticipant = person;
      if (value) {
        this.$bvModal.show(name);
      } else {
        this.$bvModal.hide(name);
      }
    },
    async closeAllModalAndRefresh() {
      this.$bvModal.hide('modal-add-participant');
      await this.$store.dispatch('callDetails/getCall', this.call._id);
      this.getParticipants();
    },
    getParticipants() {
      this.loading = true;
      AdditionalVisitorsService.getAdditionalVisitors(this.call.visitor.user_id).then(res => {
        const participants = res.data;

        if (participants && participants.length > 0) {
          this.extraParticipants = participants.filter(person => {
            let notOnVisit = true;
            if (this.additionalVisitors && this.additionalVisitors.length > 0) {
              this.additionalVisitors.forEach((additionalVisitorOnVisit) => {
                if (additionalVisitorOnVisit.additional_visitor_id === person.additional_visitor_id) {
                  notOnVisit = false;
                }
              });
            }
            return notOnVisit;
          }).map((additionalVisitor) => {
            return {
              fullName: `${additionalVisitor.firstname} ${additionalVisitor.lastname}`,
              birthDateAndAge: `${moment(additionalVisitor.dob).format('DD/MM/YYYY')} (${moment(new Date()).diff(additionalVisitor.dob, 'years')})`,
              under18: parseInt(moment(new Date()).diff(additionalVisitor.dob, 'years'), 10) < 18,
              ...additionalVisitor
            };
          });
        }
      }).catch(err => {
        this.$toast.error('Error getting visitors additional visitors. Please check your connection and refresh the page', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
      })
    },
    addParticipant(participant) {
      AdditionalVisitorsService.addAdditionalVisitorToVisit(this.call._id, participant.additional_visitor_id).then(() => {
        this.$toast.success(`${participant.firstname} added to call`, {
          toastClassName: ['toast-std', 'success-toast'],
        });
      }).catch(err => {
        const error = err && err.response && err.response.data && err.response.data.message;
        let msg = 'Could not add participant to call, please refresh and try again';

        if (error) {
          msg = error.message;
        }

        this.$toast.error(msg, {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
        this.closeAllModalAndRefresh();
      })
    },
    getNote(participant) {
      if (participant.under18 && !participant.safeguarded_at_prison) {
        return `Warning: The participant is under 18 and has not completed the safeguarding checks!`;
      }

      return '';
    }
  },
};
</script>
